import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DisbursementChecklistUI from './DisbursementChecklistUI.js'

class DisbursementChecklistSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      downloadRequested: false
    }
  }

  render() {
    return (
      <DisbursementChecklistUI
        context={this.props.context}
        onRefreshClick={this.props.onRefreshClick}
        loan={this.props.loan}
        loanBankAccount={this.props.loanBankAccount}
        onDownloadClick={this.onDownloadClick}
        downloadRequested={this.state.downloadRequested}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onDownloadClick = () => {
    this.setState({ downloadRequested: true })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/disbursements/checklist/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

}

export default DisbursementChecklistSF
